module.exports = __webpack_public_path__ + "img/4.0614964d.jpg";